import { FC, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import useStyles from "../Styles/ProjectModalStyles";
import { ConnectCorrectWalletModalProps } from "../../interfaces";
import graphQLClient from "../../utils/authHeader";
import GET_POOL_WHITELIST_STATE from "../../utils/queries/pool/getPoolWhitelistState";
import AlertContext from "../../store/Alert/AlertContext";
import { shorter } from "../../utils/web3/formatBalance";
import { ChainName, NetworkId } from "../../store/Wallet/WalletFunction";
import { useAccount, useConfig } from "wagmi";
import { switchChain } from "@wagmi/core";
import Lottie from "lottie-react";
import DisconnectAnimation from '../../assets/animations/Disconnect.json';

/**
 * Note that this component should be called switch network modal
 * TODO
 */

const ConnectCorrectWallet: FC<ConnectCorrectWalletModalProps> = ({
  open,
  setOpen,
  connectWallet,
  dismissConnectWallet,
  poolId,
  networkId,
}) => {
  const { setAlert } = useContext<any>(AlertContext);
  const theme = useTheme();
  const classes = useStyles();
  const config = useConfig();
  const isActive = useMediaQuery(theme.breakpoints.down("xs"));
  const [whitelisted, setWhitelisted] = useState(`0x0000..0000`);
  const { address: account, chain } = useAccount();
  useEffect(() => {
    if (
      account &&
      whitelisted &&
      account.toLowerCase() === whitelisted.toLowerCase() &&
      chain?.id === networkId
    ) {
      console.log("dismissing connect wallet");
      dismissConnectWallet();
      setOpen(false);
    }
  }, [account, chain, whitelisted, networkId, setOpen, dismissConnectWallet]);

  // Fetch pool whitelist data
  useEffect(() => {
    const variables = {
      poolId: poolId,
      networkId: networkId,
    };

    graphQLClient
      .request(GET_POOL_WHITELIST_STATE, variables)
      .then((data: any) => {
        setWhitelisted(data.getPoolWhitelistState.address);
      })
      .catch((error: any) => {
        setOpen(false);
        setAlert("Unable to fetch pool whitelist state.", "error");
      });
  }, []);


  const handleSwitchNetwork = (chainId: number) => {
    switchChain(config, { 
      chainId: chainId
    })
    .then(() => {
      console.info("Successfully switched network")
    })
    .catch((error: any) => {
      setAlert('Unable to switch network, please switch network manually on the wallet to continue', 'error');
    })
  }

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages}`}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            <Box mb={2} p={0} justifyContent="center" style={{ display: "flex", margin: "20px 0px 20px 0px" }}>
                <Lottie animationData={DisconnectAnimation} style={{
                    width: "196px",
                    height: "auto",
                }} />
            </Box>
            <Box mb={2} p={0} justifyContent="center" textAlign="center">
              <Typography variant="h2" color="primary">
                Wrong Network Connected
              </Typography>{" "}
            </Box>

            <Box mt={2} justifyContent="center" textAlign="center">
              <Typography
                variant="body1"
                className="text-darkslate warning-text "
              >
                {`Please connect the wallet ${shorter(
                  whitelisted
                )} to the ${ChainName(
                  networkId
                )} to continue the transaction`}
              </Typography>
            </Box>

            <Box display="flex" mt={isActive ? 3 : 5} justifyContent="center">
              <Box mr={isActive ? 0 : 1} flexGrow={isActive ? 1 : 0}>
                <Button
                  variant="contained"
                  className={`contribute-btn`}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Close
                </Button>
              </Box>
              {chain?.id !== networkId && (
                <Box ml={isActive ? 0 : 1} flexGrow={isActive ? 1 : 0}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={`contribute-btn`}
                    disabled={whitelisted === `0x0000..0000`}
                    onClick={() => {
                      handleSwitchNetwork(networkId)
                    }}
                  >
                    Switch Network
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default ConnectCorrectWallet;
